/* eslint no-shadow: 0 */
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { useTranslation } from 'react-i18next';

import AuditHistory from 'components/modules/shipments/AuditHistory';
import DataPoller from 'components/ui/DataPoller';
import CustomerStore from 'stores/CustomerSearchStore';
import CustomerActionCreators from 'actions/CustomersActionCreators';

import AccountContacts from 'components/v2/contacts';
import SessionStore from 'stores/SessionStore';
import RecentActivity from 'components/modules/user/recent-activity';
import CargomaticCard from 'components/v2/card';
import CargomaticModal from 'components/v2/modal';
import ConsigneeForm from './consignee-form';
import ConsigneeProfileCard from './consignee-profile-card';
import ConsigneeAccountCard from './consignee-account-card';
import ConsigneeAddressCard from './consignee-address-card';
import InviteConsigneeModal from './invite-consignee-modal';
import NotificationsManager from '../../notifications/manage-notifications';

const POLLING_FREQ = 10000;

const ConsigneeDetails = ({
  consignee,
  onSaveDetails,
  onChangePasswordClick,
}) => {
  const { t } = useTranslation();
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showInviteConsigneeModal, setShowInviteConsigneeModal] =
    useState(false);
  const [category, setCategory] = useState(null);
  const [audits, setAudits] = useState([]);

  const onAuditChange = () => {
    const custumerAudits = CustomerStore.getCustomerAudits();
    if (!_.isEqual(custumerAudits, audits)) {
      return setAudits(custumerAudits);
    }
  };

  const onSave = (updates) => {
    onSaveDetails(updates);
    setShowAccountModal(false);
  };

  useEffect(() => {
    const isAdminUser = SessionStore.isAdmin();
    setIsAdmin(isAdminUser);
    CustomerStore.addAuditChangeListener(onAuditChange);
  }, []);
  function renderModalComponent() {
    return (
      <ConsigneeForm
        category={category}
        details={consignee}
        onSave={(data) => onSave(data)}
      />
    );
  }

  const getUserAudits = () => {
    CustomerActionCreators.fetchCustomerAudits(consignee?._id);
  };

  function openModal(categoryName) {
    setShowAccountModal(true);
    setCategory(categoryName);
  }

  return (
    <div className="mx-auto my-16 max-w-screen-2xl md:my-32 lg:my-16">
      <DataPoller action={getUserAudits} frequency={POLLING_FREQ} />
      <div className="lg:grid lg:grid-cols-4 lg:gap-6">
        <div className="col-span-1">
          <ConsigneeProfileCard consignee={consignee} />
          <ConsigneeAccountCard
            consignee={consignee}
            onEditAccount={() => openModal('account')}
          />
          <div className="mt-6">
            <button
              className="w-full button button-hollow-red"
              onClick={onChangePasswordClick}
            >
              {t('CHANGE_PASSWORD')}
            </button>
          </div>
          {isAdmin && (
            <div className="mt-6">
              <button
                className="w-full button button-hollow-green"
                onClick={() => {
                  setShowInviteConsigneeModal(true);
                }}
              >
                {t('INVITE_CONSIGNEE')}
              </button>
            </div>
          )}
        </div>
        <div className="col-span-2">
          {isAdmin && (
            <>
              <div className="mb-6">
                <RecentActivity email={consignee?.email} />
              </div>
              <CargomaticCard
                className="mb-6"
                header={() => <h3 className="my-0">{t('AUDIT_HISTORY')}</h3>}
              >
                <AuditHistory audits={audits} paginate />
              </CargomaticCard>
            </>
          )}
          <AccountContacts
            contacts={consignee?.contacts}
            userId={consignee?._id}
            className="mb-6"
          />
          <NotificationsManager userNotificationPreferences={consignee} />
        </div>
        <div className="col-span-1">
          <ConsigneeAddressCard
            consignee={consignee}
            onEditAccount={() => openModal('address')}
          />
        </div>
      </div>
      {showAccountModal && (
        <CargomaticModal
          show
          backdrop="static"
          onHide={() => setShowAccountModal(false)}
          title={t('ACCOUNT_INFORMATION')}
          body={renderModalComponent()}
          footer={null}
          location="middle"
        />
      )}
      {showInviteConsigneeModal && (
        <InviteConsigneeModal
          consignee={consignee}
          onHideModal={() => setShowInviteConsigneeModal(false)}
        />
      )}
    </div>
  );
};

export default ConsigneeDetails;
